import { AppState } from '../../types/store';
import { VacancyAction } from './actions';
import { ADD_CANDIDATE_SUCCESS } from './actions/add-candidate-action';
import { ADD_VACANCY_LINK_SUCCESS } from './actions/add-vacancy-link-action';
import { CREATE_VACANCY_SUCCESS } from './actions/create-vacancy-action';
import { DELETE_CANDIDATE_SUCCESS } from './actions/delete-candidate-action';
import { DELETE_VACANCY_SUCCESS } from './actions/delete-vacancy-action';
import { FETCH_VACANCIES_SUCCESS } from './actions/fetch-vacancies-action';
import { INVITE_CANDIDATE_SUCCESS } from './actions/invite-candidate-action';
import { SHARE_WITH_HIRING_MANAGER_SUCCESS } from './actions/share-with-hiring-managers-action';
import { UPDATE_CANDIDATE_SUCCESS } from './actions/update-candidate-action';
import { UPDATE_VACANCY_SUCCESS } from './actions/update-vacancy-action';
import { AdministratorState, VacanciesObject, Vacancy } from './types';

export const initialState: AdministratorState = {
    vacancies: {},
};

export function reducer(state: AdministratorState = initialState, action: VacancyAction): AdministratorState {
    switch (action.type) {
        case FETCH_VACANCIES_SUCCESS:
            return {
                ...state,
                vacancies: toVacanciesObject(action.payload.data),
            };

        case CREATE_VACANCY_SUCCESS:
            return {
                ...state,
                vacancies: { ...toVacanciesObject([action.payload.data]), ...state.vacancies },
            };

        case ADD_VACANCY_LINK_SUCCESS:
        case SHARE_WITH_HIRING_MANAGER_SUCCESS:
        case UPDATE_VACANCY_SUCCESS: {
            const updatedVacancy: Vacancy = action.payload.data;
            const vacancies = { ...state.vacancies };
            vacancies[updatedVacancy.id] = updatedVacancy;
            return {
                ...state,
                vacancies,
            };
        }

        case DELETE_VACANCY_SUCCESS: {
            const { vacancyId } = action.meta.previousAction.payload;
            return {
                ...state,
                vacancies: toVacanciesObject(toVacancyArray(state.vacancies).filter((v) => v.id !== vacancyId)),
            };
        }

        case ADD_CANDIDATE_SUCCESS: {
            const { vacancyId } = action.meta.previousAction.payload;
            const vacancyToUpdate: Vacancy = Object.assign({}, state.vacancies[vacancyId], {
                candidates: [action.payload.data, ...state.vacancies[vacancyId].candidates],
            });
            return {
                ...state,
                vacancies: { ...state.vacancies, [vacancyId]: vacancyToUpdate },
            };
        }

        case UPDATE_CANDIDATE_SUCCESS:
        case INVITE_CANDIDATE_SUCCESS: {
            const { vacancyId } = action.meta.previousAction.payload;
            const candidate = action.payload.data;
            const vacancyToUpdate: Vacancy = Object.assign({}, state.vacancies[vacancyId], {
                candidates: state.vacancies[vacancyId].candidates.map((c) => (c.id === candidate.id ? candidate : c)),
            });
            return {
                ...state,
                vacancies: { ...state.vacancies, [vacancyId]: vacancyToUpdate },
            };
        }

        case DELETE_CANDIDATE_SUCCESS: {
            const { vacancyId, candidateId } = action.meta.previousAction.payload;
            const vacancyToUpdate: Vacancy = Object.assign({}, state.vacancies[vacancyId], {
                candidates: state.vacancies[vacancyId].candidates.filter((c) => c.id !== candidateId),
            });
            return {
                ...state,
                vacancies: { ...state.vacancies, [vacancyId]: vacancyToUpdate },
            };
        }

        default:
            return state;
    }
}

export const getAllVacancies = (state: AppState): Vacancy[] => toVacancyArray(state.administrator.vacancies);

export const toVacanciesObject = (vacancies: Vacancy[]) =>
    vacancies.reduce((object: VacanciesObject, resource: Vacancy) => {
        object[resource.id] = resource;
        return object;
    }, {} as VacanciesObject);

export const toVacancyArray = (object: VacanciesObject) => {
    return Object.keys(object).reduce((arr: Vacancy[], id: string) => {
        arr.push(object[id]);
        return arr;
    }, [] as Vacancy[]);
};



// WEBPACK FOOTER //
// ./src/scenes/administrator/reducer.ts